export enum LocalStorageKeys {
  IMPERSONATION_TOKEN = 'impersonation',
  MAP_LEGEND_COLLAPSED = 'mapLegendCollapsed',
  SELECTED_CLUSTER_ID = 'selectedClusterId',
  SKIP_MAINTENANCE = 'skip-maintenance',
}

export class LocalStorageService {
  public static get(key: LocalStorageKeys): string | undefined {
    const item = localStorage.getItem(key);
    if (item) {
      return item;
    } else {
      return undefined;
    }
  }

  public static set(key: LocalStorageKeys, item: string) {
    localStorage.setItem(key, item);
  }

  public static remove(key: LocalStorageKeys) {
    localStorage.removeItem(key);
  }
}
